export const leaveOrgEventSchema = {
    $id: 'urn:wisepipe-common-auth:LeaveOrgEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        isInitial: { type: 'boolean' }
    },
    required: ['orgID', 'userID']
};
//# sourceMappingURL=leaveOrgEvent.js.map